import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';

const env = import.meta.env;

const firebaseConfig = {
  apiKey: String(env.VITE_FIREBASE_API_KEY || ''),
  authDomain: String(env.VITE_FIREBASE_AUTH_DOMAIN || ''),
  projectId: String(env.VITE_FIREBASE_PROJECT_ID || ''),
  storageBucket: String(env.VITE_FIREBASE_STORAGE_BUCKET || ''),
  messagingSenderId: String(env.VITE_FIREBASE_MESSAGING_SENDER_ID || ''),
  appId: String(env.VITE_FIREBASE_APP_ID || ''),
  measurementId: String(env.VITE_FIREBASE_MEASUREMENT_ID || ''),
};

const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'appId'] as const;
const missing = requiredKeys.filter((key) => !firebaseConfig[key]);

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;

export function isFirebaseConfigured(): boolean {
  return missing.length === 0;
}

export function getFirebaseApp(): FirebaseApp {
  if (!isFirebaseConfigured()) {
    throw new Error(
      `[Sala Firebase] Faltan variables: ${missing.map((k) => `VITE_FIREBASE_${k}`).join(', ')}`,
    );
  }
  if (!app) {
    const existing = getApps().find((candidate) => candidate.name === 'sala');
    app = existing ?? initializeApp(firebaseConfig, 'sala');
  }
  return app;
}

export function getSalaAuth(): Auth {
  if (!auth) auth = getAuth(getFirebaseApp());
  return auth;
}

export function getSalaDb(): Firestore {
  if (!db) db = getFirestore(getFirebaseApp());
  return db;
}
